import axios from "axios";
import Config from "../utilities/Config";
const BASE_URL = `${Config.baseUrl}api/admin`;

class PostPaidManagement {
  getHeaders() {
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem(
        "txtconnect_ng_admin_token"
      )}`,
    };
  }

  handleSuccess(response) {
    return {
      status: true,
      data: response.data.data,
      message: response.data.message,
    };
  }

  handleError(error, defaultMessage) {
    return {
      status: false,
      data: null,
      message: error.response?.data?.message || defaultMessage,
    };
  }

  async getAllPostPaidRequests() {
    try {
      const response = await axios.get(`${BASE_URL}/postpaid_requests`, {
        headers: this.getHeaders(),
      });
      return this.handleSuccess(response);
    } catch (error) {
      return this.handleError(error, "Error fetching post paid requests");
    }
  }

  async createPostPaidRequest(payload) {
    try {
      const response = await axios.post(
        `${BASE_URL}/postpaid_requests/create`,
        payload,
        { headers: this.getHeaders() }
      );
      return this.handleSuccess(response);
    } catch (error) {
      return this.handleError(error, "Error creating post paid request");
    }
  }

  async updatePostPaidRequest(payload, requestId) {
    try {
      const response = await axios.put(
        `${BASE_URL}/postpaid_requests/update/${requestId}`,
        payload,
        { headers: this.getHeaders() }
      );
      return this.handleSuccess(response);
    } catch (error) {
      return this.handleError(error, "Error updating post paid request");
    }
  }

  async PostPaidRequestApproval(payload, requestId) {
    try {
      const response = await axios.post(
        `${BASE_URL}/postpaid-requests/${requestId}/approval`,
        payload,
        { headers: this.getHeaders() }
      );
      return this.handleSuccess(response);
    } catch (error) {
      return this.handleError(
        error,
        "Error approving custom plan payment request"
      );
    }
  }

  async showPostPaidRequest(requestId) {
    try {
      const response = await axios.get(
        `${BASE_URL}/show_postpaid_requests/${requestId}`,
        {
          headers: this.getHeaders(),
        }
      );
      return this.handleSuccess(response);
    } catch (error) {
      return this.handleError(error, "Error showing post paid request");
    }
  }
}
const postPaidManagement = new PostPaidManagement();
export default postPaidManagement;
